import { render, staticRenderFns } from "./workstation_total.vue?vue&type=template&id=68c7b326&scoped=true&"
import script from "./workstation_total.vue?vue&type=script&lang=js&"
export * from "./workstation_total.vue?vue&type=script&lang=js&"
import style0 from "./workstation_total.vue?vue&type=style&index=0&id=68c7b326&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c7b326",
  null
  
)

export default component.exports